var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.388,
    height: 58.379,
    viewBox: "0 0 58.388 58.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.956,
    x2: 2.127,
    y2: 0.94,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edd47a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cab56d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "screwdriver-and-wrench-crossed",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Agrupar_210",
    "data-name": "Agrupar 210",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Agrupar_209",
    "data-name": "Agrupar 209",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Agrupar_208",
    "data-name": "Agrupar 208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_253",
    "data-name": "Caminho 253",
    d: "M1.6,277.3a5.468,5.468,0,0,0,7.735,7.732l17.953-17.957-7.735-7.728Z",
    transform: "translate(-0.001 -228.251)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_254",
    "data-name": "Caminho 254",
    d: "M289.386,15.811l7.819-4.043L301.3,3.855,297.483.038l-7.91,4.1-4.05,7.812-9.51,9.521,3.857,3.864Z",
    transform: "translate(-242.915 -0.038)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_255",
    "data-name": "Caminho 255",
    d: "M48.653,36.563l-.736-.073a10.847,10.847,0,0,0-3.78.711L21.693,14.754a10.847,10.847,0,0,0,.711-3.78l-.073-.736A10.827,10.827,0,0,0,6.78,1.132L14.045,8.4a3.566,3.566,0,0,1,.82,1.312A3.642,3.642,0,0,1,8.89,13.547L1.626,6.286a10.827,10.827,0,0,0,9.106,15.551l.736.073a10.93,10.93,0,0,0,3.78-.707l22.44,22.444a11.012,11.012,0,0,0-.7,3.78l.077.736a10.893,10.893,0,0,0,10.859,10.2,10.706,10.706,0,0,0,4.688-1.094L45.343,50a3.722,3.722,0,0,1-.828-1.309,3.634,3.634,0,0,1,3.4-4.914,3.585,3.585,0,0,1,1.269.248,3.5,3.5,0,0,1,1.309.82l7.265,7.265a10.782,10.782,0,0,0,1.094-4.688A10.91,10.91,0,0,0,48.653,36.563Z",
    transform: "translate(-0.468 -0.038)",
    fill: "url(#linear-gradient)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdSupport);
export default __webpack_public_path__ + "static/media/mdSupport.815a48008f2e78f9e54724aac8ff515d.svg";
export { ForwardRef as ReactComponent };